import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Humble from "../cases/Humble/humble"

const HumbleVentureCapital = () => (
    <Layout>
        <SEO title="Humble VC | Ryan Luu" />
        <Humble />
    </Layout>
)

export default HumbleVentureCapital